export const getSignInButtonClassNames = (accountSignInButtonStyle = '') =>
  `v3-btn v3-btn-text v3-login-btn btn ${
    accountSignInButtonStyle ? `btn ${accountSignInButtonStyle}` : ''
  }`;

export const getSignUpButtonClassNames = (accountSignUpButtonStyle = '') =>
  `v3-btn v3-btn-primary v3-register-btn ${
    accountSignUpButtonStyle ? `btn ${accountSignUpButtonStyle}` : ''
  }`;
